import { createContext } from 'react';

import { createTheme } from '@material-ui/core/styles';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

const defaultTheme = createTheme({});

let primaryColor = '#6A11CB';
let commonColors = {
  orange: '#FA7A25',
  danger: '#dc3545',
  blue: '#0E9FEB',
  green: '#25DF21',
};
Object.entries(commonColors).forEach(([k, v]) => {
  commonColors[`${k}Dark`] = darken(v, 0.2);
  commonColors[`${k}Darker`] = darken(v, 0.4);
  commonColors[`${k}Light`] = lighten(v, 0.2);
  commonColors[`${k}Lighter`] = lighten(v, 0.9);
});

export const freightLegendTheme = createTheme({
  palette: {
    common: commonColors,
    primary: {
      // light: will be calculated from palette.primary.main,
      main: primaryColor,
      dark: darken(primaryColor, 0.2),
      darker: darken(primaryColor, 0.4),
      light: lighten(primaryColor, 0.2),
      lighter: lighten(primaryColor, 0.9),
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: '#0066ff',
      main: '#ffffff',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: '#ffcc00',
    },
    text: {
      secondary: defaultTheme.palette.grey[300],
    },
  },
  // status: {
  //    danger: 'orange',
  // },
  typography: {
    fontFamily: [
      'Source Sans Pro',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      outlinedSecondary: {
        borderWidth: '2px',
        '&:hover': {
          borderWidth: '2px',
        },
      },
    },
    MuiToggleButton: {
      root: {
        textTransform: 'none',
        color: '#ffffff',
        '&$selected': {
          color: '#ffffff',
        },
        paddingTop: defaultTheme.spacing(1),
        paddingBottom: defaultTheme.spacing(1),
        height: 'auto',
        minWidth: '100px',
      },
    },
    MuiTypography: {
      h1: {
        fontSize: '32px',
        fontWeight: '600',
        color: '#ffffff',
        marginTop: defaultTheme.spacing(2),
        marginBottom: defaultTheme.spacing(2),
      },
      h4: {
        fontSize: '21px',
        fontWeight: '600',
        lineHeight: '26px',
      },
      h5: {
        fontSize: '16px',
        fontWeight: '600',
      },
      caption: {
        fontWeight: 'bold',
        letterSpacing: '0.05em',
      },
      subtitle2: {
        fontSize: '12px',
        color: '#07020D',
        opacity: 0.4,
      },
    },

    MuiInputBase: {
      input: {
        backgroundColor: defaultTheme.palette.grey[200],
        padding: defaultTheme.spacing(1),
      },
    },
    MuiInput: {
      formControl: {
        'label + &': {
          marginTop: defaultTheme.spacing(2.5),
        },
      },
    },
    MuiSelect: {
      select: {
        borderRadius: defaultTheme.spacing(1),
        '&:focus': {
          borderRadius: defaultTheme.spacing(1),
        },
        minWidth: '60px',
        minHeight: '19px',
      },
    },
    MuiTab: {
      wrapper: {
        fontWeight: 'bold',
        fontSize: '14px',
        letterSpacing: '0.1em',
      },
    },
    MuiTablePagination: {
      root: {
        color: defaultTheme.palette.primary.main,
      },
    },
    MuiTableCell: {
      head: {
        fontSize: '12px',
      },
      sizeSmall: {
        lineHeight: 1.2,
      },
    },
  },
});

// set the defaults
const ThemeContext = createContext({
  theme: {},
  updateTheme: (theme) => {},
  useDefaultTheme: () => {},
});

export default ThemeContext;
